import { IMAGE_TYPES } from '../../constants';

export const DEFAULT_ACCEPT_TYPES = [IMAGE_TYPES.JPEG, IMAGE_TYPES.JPG, IMAGE_TYPES.PNG].join(', ');
